import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3 mb-md-4" }
const _hoisted_4 = { class: "default-table-area all-products" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table align-middle" }
const _hoisted_7 = { class: "text-body" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "ms-2 ps-1" }
const _hoisted_10 = { class: "fw-medium fs-14 mb-0" }
const _hoisted_11 = { class: "text-secondary" }
const _hoisted_12 = { class: "text-secondary text-end" }
const _hoisted_13 = { class: "text-secondary text-end" }
const _hoisted_14 = { class: "text-secondary text-end" }
const _hoisted_15 = { class: "text-secondary text-end" }
const _hoisted_16 = { class: "text-secondary text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_PaginationTwo = _resolveComponent("PaginationTwo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "position-relative table-src-form me-0",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Search here",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event))
          }, null, 512), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y" }, " search ", -1))
        ], 32),
        _cache[3] || (_cache[3] = _createElementVNode("select", {
          class: "form-select month-select form-control p-0 h-auto border-0 w-90",
          style: {"background-position":"right 0 center"},
          "aria-label": "Default select example"
        }, [
          _createElementVNode("option", { selected: "" }, "This Month"),
          _createElementVNode("option", { value: "1" }, "Last Month"),
          _createElementVNode("option", { value: "2" }, "Last Year")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "ID"),
                _createElementVNode("th", { scope: "col" }, "Customer"),
                _createElementVNode("th", { scope: "col" }, "Date"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-end"
                }, "No. Order Returned"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-end"
                }, "No. Order Refunded"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-end"
                }, "No. Order Replaced"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-end"
                }, "Total Refunded"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-end"
                }, "Total Replaced")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", _hoisted_7, _toDisplayString(item.id), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, {
                      to: "/my-profile",
                      class: "d-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: item.customer.image,
                          class: "wh-40 rounded-circle",
                          alt: "user"
                        }, null, 8, _hoisted_8),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("h6", _hoisted_10, _toDisplayString(item.customer.name), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(item.date), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(item.noOrderReturned), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(item.noOrderRefunded), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(item.noOrderReplaced), 1),
                  _createElementVNode("td", _hoisted_15, " $" + _toDisplayString(item.totalRefunded), 1),
                  _createElementVNode("td", _hoisted_16, " $" + _toDisplayString(item.totalReplaced), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createVNode(_component_PaginationTwo, {
          items: "10",
          total: _ctx.items.length
        }, null, 8, ["total"])
      ])
    ])
  ]))
}